<template>
  <v-container fluid>
    <v-skeleton-loader :loading="loading" :types="skeleton" type="article" class="mb-6">
      <OrderElectricityEditForm
        v-if="order.electricityOrder"
        v-model="order"
        title="Editace objednávky"
        :edit="true"
        :saving="saving"
        @save="saveElectricityOrder"
      />
      <OrderElectricityWorkEditForm
        v-if="order.electricityWorkOrder"
        v-model="order"
        title="Editace objednávky"
        :edit="true"
        :saving="saving"
        @save="saveElectricityWorkOrder"
      />
      <OrderGasEditForm
        v-if="order.gasOrder"
        v-model="order"
        title="Editace objednávky"
        :edit="true"
        :saving="saving"
        @save="saveGasOrder"
      />
    </v-skeleton-loader>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'
import OrderGasEditForm from '@/components/forms/OrderGasEditForm'
import OrderElectricityEditForm from '@/components/forms/OrderElectricityEditForm'
import OrderElectricityWorkEditForm from '../../../components/forms/OrderElectricityWorkEditForm'

export default {
  name: 'OrderElectricityEdit',
  components: { OrderElectricityWorkEditForm, OrderElectricityEditForm, OrderGasEditForm },
  data() {
    return {
      skeleton: {
        article: 'heading, paragraph@2',
      },
      order: {
        electricityOrder: {},
        electricityWorkOrder: {},
        gasOrder: {},
        moveOrder: {},
        questionOrder: {},
      },
      loading: false,
      saving: false,
    }
  },
  created() {
    this.loadOrder()
  },
  methods: {
    ...mapActions({
      getOrder: 'order/getOrder',
      updateElectricityOrder: 'electricity/updateOrder',
      updateElectricityWorkOrder: 'electricity/updateWorkOrder',
      updateGasOrder: 'gas/updateOrder',
    }),
    loadOrder() {
      this.loading = true
      this.getOrder(this.$route.params.orderId)
        .then((response) => {
          this.order = response.data
        })
        .finally(() => {
          this.loading = false
        })
    },
    saveElectricityOrder() {
      this.saving = true
      this.updateElectricityOrder(this.order)
        .then((response) => {
          if (response.status === 200 || response.status === 201) {
            this.$router.push({
              name: 'orders.detail',
              params: { id: response.data.id },
            })
          }
        })
        .finally(() => {
          this.saving = false
        })
    },
    saveElectricityWorkOrder() {
      this.saving = true
      this.updateElectricityWorkOrder(this.order)
        .then((response) => {
          if (response.status === 200 || response.status === 201) {
            this.$router.push({
              name: 'orders.detail',
              params: { id: response.data.id },
            })
          }
        })
        .finally(() => {
          this.saving = false
        })
    },
    saveGasOrder() {
      this.saving = true
      this.updateGasOrder(this.order)
        .then((response) => {
          if (response.status === 200 || response.status === 201) {
            this.$router.push({
              name: 'orders.detail',
              params: { id: response.data.id },
            })
          }
        })
        .finally(() => {
          this.saving = false
        })
    },
  },
}
</script>
